import moment from "moment";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getDownloadFileUrl } from "views/pages/manage/edpOps/constant/common";
import { masterServiceBaseUrl, enrollmentServiceBaseUrl } from "services/http";
import { getInputParamRegex, multiValuesSearchPasteHandler } from "views/pages/manage/edpOps/constant/student-search";
// import {
//   getInputParamRegex,
//   multiValuesSearchPasteHandler,
// } from "../../edpOps/constant/student-search";

export const paymentSlabStatusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];


export const fetchSlabDetails = async (slabId, {offset = 0, pageSize = 10}) => {
  const response = await fetchAllPromisedData(
    `${endpoint.commissionSlab.create}/${slabId}?page=${offset}&size=${pageSize}`,
  );

  return response || null;
};

export const createConcessionSlab = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.create}/`,
    payload,
    "post",
  );
  return response?.data || null;
};

export const updateSlabDetails = async (slabId, payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.create}/${slabId}`,
    payload,
    'put'
  );
  return response;
};
export const updateCommissionSlabRow = async (id, payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.createSlab}/${id}`,
    payload,
    "put",
  );
  return response || null;
};

export const createCommissionSlabRow = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.createSlab}`,
    payload,
    "post",
  );
  return response|| null;
};

export const fetchStateAndYearDropdowns = async () => {
  // Fetch state and year dropdowns from master APIs in parallel
  const [yearRes] = await Promise.all([
    fetchAllPromisedData(endpoint.academic_year.getAllActive),
  ]);

  const yearOptions = yearRes.map((item) => ({
    label: item.academicYearDisplayValue,
    value: item.academicYearDisplayValue,
  }));

  return {
    yearOptions,
  };
};

export const fetchCommissionSlabDropdowns = async () => {
  // Fetch all required dropdowns in parallel
  const [careerRes, courseAttrRes, courseAttrMappingRes,businessActiveAreas, academicGroupRes] =
    await Promise.all([
      fetchAllPromisedData(endpoint.academic_career.getAllActive),
      fetchAllPromisedData(endpoint.courseAttribute.getAllActive),
      fetchAllPromisedData(
        endpoint.courseAttributeValue.getAllCourseAttributeValue,
      ),
      fetchAllPromisedData(endpoint.businessArea.getAllActiveV2),
      fetchAllPromisedData(endpoint.academic_group.getAllActive),
      
    ]);

  const careerOptions = careerRes.map((item) => ({
    label: item.academicCareerDispValue,
    value: item.id,
  }));
  const courseAttributeOptions = courseAttrRes.map((item) => ({
    label: item.courseAttributeDispValue,
    value: item.id,
    desc: item.courseAttributeDesc,
    key: item.courseAttributeKey,
  }));

  const courseAttributeValueMap = courseAttrMappingRes.map((item) => ({
    label: item.courseAttributeValueDispValue,
    value: item.id,
    desc: item.courseAttributeValueDesc,
    key: item.courseAttributeValueKey,
  }));

  const academicGroupOptions = academicGroupRes.map((item) => ({
    label: item.academicGroupDispValue,
    value: item.id,
  }));

  const extensionBusinessUnits = businessActiveAreas.map((item) => ({
    label: item.businessAreaDispValue,
    value: item.businessAreaDispValue,
  }));

  return {
    careerOptions,
    courseAttributeOptions,
    courseAttributeValueMap,
    academicGroupOptions,
    extensionBusinessUnits,
  };
};
export const searchCommissionSlab = async (payload, offset, limit) => {
  // API expects offset (page number) and limit (page size)
  const url = `${endpoint.commissionSlab.search}?page=${offset}&size=${limit}`;
  const response = await fetchAllPostPromisedData(url, payload);

  return response;
};
